export const removeIconsFromSessionStorage = (profileId: string, shouldRemoveSmallIcon = false): void => {
  sessionStorage.removeItem(`browserIconsDesign:${profileId}`);
  sessionStorage.removeItem(`browserIconBig:${profileId}`);
  if (shouldRemoveSmallIcon) {
    sessionStorage.removeItem(`browserIconSmall:${profileId}`);
  }
};
